import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import css from './OwnerAboutEmptyWelcomeVideoCard.module.css';

const OwnerAboutEmptyWelcomeVideoCard = ({ className }) => (
  <div className={classNames(css.card, className)}>
    <div className={css.iconWrapper}>
      <i className="ri-play-circle-line" aria-hidden />
    </div>
    <h3 className={css.title}>
      <FormattedMessage
        id="StoreProfilePage.about.emptyVideo.title"
        defaultMessage="Add a welcome video"
      />
    </h3>
    <p className={css.description}>
      <FormattedMessage
        id="StoreProfilePage.about.emptyVideo.description"
        defaultMessage="Introduce your store and build trust with renters."
      />
    </p>
    <NamedLink name="StoreBasicInformationPage" className={css.ctaLink}>
      <FormattedMessage
        id="StoreProfilePage.about.emptyVideo.cta"
        defaultMessage="Upload video"
      />
      <i className={classNames('ri-arrow-right-up-line', css.ctaArrow)} aria-hidden />
    </NamedLink>
  </div>
);

OwnerAboutEmptyWelcomeVideoCard.propTypes = {
  className: PropTypes.string,
};

export default OwnerAboutEmptyWelcomeVideoCard;
